var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "conteneurLead", attrs: { flat: "" } },
    [
      _c(
        "v-card-title",
        {
          staticClass: "primary white--text",
          staticStyle: { height: "52px", padding: "0px" }
        },
        [
          _c(
            "v-btn",
            {
              attrs: { icon: "" },
              on: {
                click: function($event) {
                  return _vm.cancelDialog()
                }
              }
            },
            [_c("v-icon", { staticClass: "white--text" }, [_vm._v("close")])],
            1
          ),
          _vm._v(" "),
          _c("span", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("statSuperv8")))
          ]),
          _vm._v(" "),
          _c("v-spacer")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card-text",
        [
          _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              _vm.loading
                ? _c(
                    "v-card",
                    { staticClass: "mb-3", attrs: { height: "400px" } },
                    [
                      _c(
                        "v-card-text",
                        { staticClass: "text-xs-center pt-5" },
                        [
                          _c("v-progress-circular", {
                            staticClass: "primary--text",
                            attrs: { indeterminate: "" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              !_vm.loading
                ? _c(
                    "v-card",
                    { staticClass: "mb-3" },
                    [
                      _c(
                        "v-flex",
                        { attrs: { "d-flex": "", xs12: "" } },
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { "d-flex": "", md12: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    { attrs: { xs12: "" } },
                                    [
                                      _c("highcharts", {
                                        attrs: { options: _vm.agentConnexions }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { "d-flex": "", md12: "" } },
                                [
                                  _c("p", { staticClass: "totalTime" }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("statSuperv21")) + " : "
                                    ),
                                    _c("strong", [
                                      _vm._v(_vm._s(_vm.totalConnexionAgents))
                                    ])
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            "max-width": "1200px",
            scrollable: !_vm.$vuetify.breakpoint.smAndDown,
            fullscreen: _vm.$vuetify.breakpoint.smAndDown
          },
          model: {
            value: _vm.occupationAgentDay,
            callback: function($$v) {
              _vm.occupationAgentDay = $$v
            },
            expression: "occupationAgentDay"
          }
        },
        [
          _vm.occupationAgentDay
            ? _c("wz-agents-occupation-day", {
                attrs: { dataAgentSelected: _vm.dataAgentSelected },
                on: { closeDialog: _vm.dialogOccupationRemove }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5575c1a2", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5575c1a2","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzAgentsPresenceDay.vue
// module id = null
// module chunks = 